import React, { useContext, useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import MenuItem from "./MenuItem";
import { GlobalContext } from "@/context/globalContext";
import dynamic from "next/dynamic";
import { useOverflow } from "@/hooks/useOverflow";

const MobileMenu = dynamic(() => import("@/components/Header/MobileMenu"));

const MainMenu = ({ dataHeader }) => {
  const { setZIndex } = useContext(GlobalContext);

  const slicedDataHeader = dataHeader?.navMenu;
  const [isOpen, setIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [width, setWidth] = useState(0);

  // hiding overflow in body
  useOverflow(isOpen);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <button
        onClick={() => {
          setIsOpen(true);
          setZIndex(true);
        }}
        className="border-black lg:hidden"
      >
        <Menu size={24} />
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 z-40 transition-opacity duration-300 ease-in-out bg-black bg-opacity-50"
          onClick={() => {
            setIsOpen(false);
            setZIndex(false);
          }}
        />
      )}
      <div
        className={`lg:static fixed top-0 left-0 lg:h-auto h-full lg:w-auto w-80 lg:overflow-y-visible overflow-y-auto  bg-white lg:shadow-none shadow-lg transform transition-transform duration-300 ease-in-out z-50 ${
          isOpen ? "translate-x-0" : "lg:translate-x-0 -translate-x-full"
        }`}
      >
        <div className="sticky top-0 left-0 bg-white flex items-center justify-between p-4 border-b lg:hidden">
          <span className="text-xl font-semibold">Menü</span>
          <button
            onClick={() => {
              setIsOpen(false);
              setZIndex(false);
            }}
            className="p-1 rounded-full hover:bg-gray-100"
          >
            <X size={24} className="text-gray-600" />
          </button>
        </div>
        {width >= 1024 && (
          <nav className="hidden p-4 lg:p-0 lg:block">
            <ul className="flex flex-col items-center lg:flex-row xl:gap-8">
              {slicedDataHeader?.map((nav) => (
                <MenuItem
                  key={nav?.id}
                  nav={nav}
                  isActive={activeMenu === nav.id}
                  setActiveMenu={setActiveMenu}
                />
              ))}
            </ul>
          </nav>
        )}
        <div className="px-5 space-y-4 lg:hidden">
          {isOpen && (
            <MobileMenu dataHeader={dataHeader} setIsOpen={setIsOpen} />
          )}
        </div>
      </div>
    </>
  );
};

export default MainMenu;
